import { useState, useReducer, useEffect } from 'react';
import { isNotNil, isNil } from '../../../helpers/utils';
import { isSSR } from '@front10/utils';
import dayjs from 'dayjs';
import { getAirports } from '../../../_integrations/everymundo/airports';

export const NOT_AVALIABLES_DAYS = -1;
export function getValidStartDate(date, flexibleDates, availableDays, start = 0) {
  const departure = dayjs().add(start, 'day');
  let startDate = dayjs(new Date(date)).add(-flexibleDates, 'day').toDate();

  if (dayjs(startDate).isBefore(departure)) {
    startDate = departure.toDate();
  }
  if (availableDays !== undefined && availableDays !== NOT_AVALIABLES_DAYS) {
    const endDateAvaliableDays = dayjs(new Date()).add(availableDays, 'day');
    return (dayjs(startDate).isAfter(dayjs(new Date())) ||
      dayjs(startDate).isSame(dayjs(new Date()), 'date')) &&
      (dayjs(startDate).isBefore(endDateAvaliableDays) ||
        dayjs(startDate).isSame(endDateAvaliableDays, 'date'))
      ? startDate
      : new Date();
  } else {
    return dayjs(startDate).isAfter(dayjs(new Date())) ||
      dayjs(startDate).isSame(dayjs(new Date()), 'date')
      ? startDate
      : new Date(date);
  }
}

export function getValidEndDate(date, flexibleDates, availableDays) {
  const endDate = dayjs(new Date(date)).add(flexibleDates, 'day').toDate();
  if (availableDays !== undefined && availableDays !== NOT_AVALIABLES_DAYS) {
    const endDateAvaliableDays = dayjs(new Date()).add(availableDays - 1, 'day');
    return (dayjs(endDate).isAfter(dayjs(new Date())) ||
      dayjs(endDate).isSame(dayjs(new Date()), 'date')) &&
      (dayjs(endDate).isBefore(endDateAvaliableDays) ||
        dayjs(endDate).isSame(endDateAvaliableDays, 'date'))
      ? endDate
      : endDateAvaliableDays;
  } else {
    return dayjs(endDate).isAfter(dayjs(new Date())) ||
      dayjs(endDate).isSame(dayjs(new Date()), 'date')
      ? endDate
      : new Date(date);
  }
}

export function tagsFromTravelerInterest(travelerInterestRaw) {
  const response = [];
  Object.keys(travelerInterestRaw).forEach((key) => {
    if (
      Boolean(travelerInterestRaw[key]) &&
      Array.isArray(travelerInterestRaw[key].selectedItems)
    ) {
      const { selectedItems } = travelerInterestRaw[key];
      selectedItems.forEach((item) => item.value !== 'any' && response.push(item.value));
    }
  });
  return response;
}

const mapFilter = ({
  prePopulation,
  sorting,
  paginationIndex: currentPaginationIndex = undefined,
  faresTransformationLogic,
  dateRange = {},
  budget = undefined,
  stops = undefined,
  origin = undefined,
  destination = undefined,
  tripDuration = undefined,
  flightStopCount = undefined,
  isPrePopulation,
  selectedAirlines = undefined,
  rating = undefined,
  travelerInterest = {},
  histogramType,
  combinable,
  ignoreCurrencyCode,
  isMobile,
  ...restFilter
}) => {
  const filterModified = { ...prePopulation, ...restFilter };

  if (faresTransformationLogic === 'histogram') {
    filterModified.origin = origin;
    filterModified.destination = destination;
    filterModified.dateRange = dateRange;
  } else {
    let sortingFilter = prePopulation.sorting;
    if (isNotNil(sorting) && Array.isArray(sorting)) {
      sortingFilter = sorting;
    } else if (sorting && typeof sorting === 'string') {
      switch (sorting) {
        case 'price_low_to_hight': // Deprecated, this was a typo
        case 'price_low_to_high':
          sortingFilter = [
            {
              usdTotalPrice: 'ASC'
            }
          ];
          break;
        case 'price_hight_to_low': // Deprecated, this was a typo
        case 'price_high_to_low':
          sortingFilter = [
            {
              usdTotalPrice: 'DESC'
            }
          ];
          break;
        case 'departure_date':
          sortingFilter = [
            {
              departureDate: 'ASC'
            }
          ];
          break;
        case 'most_popular':
          sortingFilter = [{ popularity: 'DESC' }];
          break;
        case 'price_specification_low_to_high':
          sortingFilter = [{ 'priceSpecification.usdTotalPrice': 'ASC' }];
          break;
        case 'price_specification_high_to_low':
          sortingFilter = [{ 'priceSpecification.usdTotalPrice': 'DESC' }];
          break;
        case 'star_rating_high_to_low':
          sortingFilter = [{ 'hotel.rating.value': 'DESC' }];
          break;
        case 'star_rating_low_to_high':
          sortingFilter = [{ 'hotel.rating.value': 'ASC' }];
          break;
        case 'duration_high_to_low':
          sortingFilter = [{ 'journey.flightDeltaDays': 'DESC' }];
          break;
        case 'duration_low_to_high':
          sortingFilter = [{ 'journey.flightDeltaDays': 'ASC' }];
          break;
        case 'no_sorting':
          sortingFilter = [];
          break;
        default:
          break;
      }
    }
    filterModified.sorting = sortingFilter;

    delete filterModified.origin;
    delete filterModified.destination;
    if (!isPrePopulation) {
      filterModified.origins = origin ? [origin] : prePopulation.origins;
      filterModified.destinations = destination ? [destination] : prePopulation.destinations;
    } else {
      if (prePopulation.origin) {
        filterModified.origins = [prePopulation.origin];
      }
      if (prePopulation.destination) {
        filterModified.destinations = [prePopulation.destination];
      }
    }

    delete filterModified.dateRange;
    const start = prePopulation.departure?.start ? prePopulation.departure.start : 0;
    if (prePopulation.flightType === 'COMBINED') {
      filterModified.departure = dateRange.start
        ? {
            start: getValidStartDate(
              dateRange.start,
              dateRange.flexibleDates,
              dateRange.availableDays,
              start
            ),
            end: getValidEndDate(dateRange.start, dateRange.flexibleDates, dateRange.availableDays)
          }
        : { ...filterModified.departure };
      if (dateRange.end) {
        filterModified.return = {
          start: getValidStartDate(
            dateRange.end,
            dateRange.flexibleDates,
            dateRange.availableDays,
            start
          ),
          end: getValidEndDate(dateRange.end, dateRange.flexibleDates, dateRange.availableDays)
        };
      }
    } else if (prePopulation.flightType === 'ROUND_TRIP') {
      if (dateRange.start && !dateRange.end) {
        filterModified.departure = {
          start: getValidStartDate(
            dateRange.start,
            dateRange.flexibleDates,
            dateRange.availableDays,
            start
          ),
          end: getValidEndDate(dateRange.start, dateRange.flexibleDates, dateRange.availableDays)
        };
      } else if (dateRange.end && !dateRange.start) {
        const date = getValidStartDate(
          dateRange.end,
          dateRange.flexibleDates,
          dateRange.availableDays,
          start
        );
        filterModified.departure = {
          start: date,
          end: date
        };
        filterModified.return = {
          start: date,
          end: date
        };
      } else {
        filterModified.departure = dateRange.start
          ? {
              start: getValidStartDate(
                dateRange.start,
                dateRange.flexibleDates,
                dateRange.availableDays,
                start
              ),
              end: getValidEndDate(
                dateRange.start,
                dateRange.flexibleDates,
                dateRange.availableDays
              )
            }
          : { ...filterModified.departure };
        if (dateRange.end) {
          filterModified.return = {
            start: getValidStartDate(
              dateRange.end,
              dateRange.flexibleDates,
              dateRange.availableDays,
              start
            ),
            end: getValidEndDate(dateRange.end, dateRange.flexibleDates, dateRange.availableDays)
          };
        }
      }
    } else {
      const rangeSelected = dateRange.start && dateRange.end;
      const departSelected = !!dateRange.start;
      if (rangeSelected) {
        filterModified.departure = {
          start: getValidStartDate(
            dateRange.start,
            dateRange.flexibleDates,
            dateRange.availableDays,
            start
          ),
          end: getValidEndDate(dateRange.end, dateRange.flexibleDates, dateRange.availableDays)
        };
      } else if (departSelected) {
        filterModified.departure = {
          start: getValidStartDate(
            dateRange.start,
            dateRange.flexibleDates,
            dateRange.availableDays,
            start
          ),
          end: getValidEndDate(dateRange.start, dateRange.flexibleDates, dateRange.availableDays)
        };
      } else {
        filterModified.departure = { ...filterModified.departure };
      }
    }
  }

  if (isNotNil(currentPaginationIndex)) {
    if (faresTransformationLogic === 'aggregation') {
      filterModified.faresLimit = currentPaginationIndex;
    } else {
      filterModified.routesLimit = currentPaginationIndex;
    }
  }

  delete filterModified.stops;
  if (stops !== 'any' && isNotNil(stops)) {
    const stopsNumber = typeof stops === 'string' ? Number.parseInt(stops, 10) : stops;
    filterModified.stops = {
      type: 'FLIGHT_STOP_COUNT',
      range: {
        min: 0,
        max: stopsNumber
      }
    };
  }

  delete filterModified.flightStopCount;
  if (flightStopCount !== 'Any' && isNotNil(flightStopCount)) {
    filterModified.flightStopCount = {
      minimum: 0,
      maximum: flightStopCount
    };
  }

  if (filterModified.redemptionUnit === 'CASH') {
    delete filterModified.redemptionUnit;
  }

  if (budget) {
    if (budget?.maximum || budget?.minimum) {
      let newBudget = {};
      if (budget?.maximum) {
        newBudget['maximum'] = budget?.maximum;
      }
      if (budget?.minimum) {
        newBudget['minimum'] = budget?.minimum;
      }
      filterModified.budget = { ...newBudget };
    } else {
      filterModified.budget = { maximum: budget };
    }
  }

  Object.keys(filterModified).forEach((key) => {
    const value = filterModified[key];
    if (isNil(value)) {
      delete filterModified[key];
    } else if (Array.isArray(value) && value[0] === null && value.length === 1) {
      // FIXME: This deletes arrays of the form [null], which are usually a product
      // of context evaluation. We should make context evaluation to be able to
      // handle this case correctly and not send this value.
      delete filterModified[key];
    }
  });

  /**
   * If an origin is defined as part of the request, a market should not be sent.
   * https://everymundo.atlassian.net/browse/FC-2178
   */
  if (filterModified.origin || (filterModified.origins && filterModified.origins[0])) {
    delete filterModified.markets;
  }

  if (
    selectedAirlines !== null &&
    selectedAirlines !== undefined &&
    selectedAirlines.length !== 0
  ) {
    filterModified.includedTenants = selectedAirlines.value;
  }

  if (filterModified.airlines !== undefined) {
    delete filterModified.airlines;
  }

  if (!tripDuration || (tripDuration && (!tripDuration.minimum || !tripDuration.maximum))) {
    delete filterModified.tripDuration;
  } else {
    filterModified.tripDuration = tripDuration;
  }

  if (rating && typeof rating === 'object') {
    if (rating.value) {
      filterModified.rating = { minimum: rating.value, maximum: rating.value };
    } else if (rating.minimum !== 0 || rating.maximum !== 5) {
      filterModified.rating = rating;
    } else {
      delete filterModified.rating;
    }
  } else {
    delete filterModified.rating;
  }

  if (travelerInterest) {
    const tags = tagsFromTravelerInterest(travelerInterest);
    if (tags.length > 0) {
      // POr configuracion determinar para donde se envian los tags
      // POr configuración determinar el hierarchy: airport/city/state/country/region
      filterModified['destinationHierarchy'] = {
        tags
      };
    }
    delete filterModified.travelerInterest;
  }

  if (faresTransformationLogic === 'histogram') {
    if (ignoreCurrencyCode) {
      filterModified.ignoreCurrencyCode = true;
    }
    if (combinable) {
      filterModified.flightType = 'ONE_WAY';
      if (dateRange?.action === 'FLIGHT_TYPE_CHANGE_TO_ROUND_TRIP' && dateRange?.departureDate) {
        filterModified.dateRange = {
          ...filterModified.dateRange,
          action: 'combinable-destination-origin-filter-change'
        };
      }
      if (!isMobile) {
        const flightType = restFilter.flightType;
        if (
          (dayjs(dateRange?.departureDate).month() === dayjs(dateRange?.start).month() ||
            dayjs(dateRange?.departureDate).month() === dayjs(dateRange?.end).month()) &&
          ((dateRange?.departureDate && !dateRange.returnDate && flightType !== 'ONE_WAY') ||
            (dateRange?.departureDate &&
              dateRange.returnDate &&
              dateRange?.action?.includes('DEPARTURE_DATE')))
        ) {
          filterModified.dateRange = {
            ...filterModified.dateRange,
            start: filterModified.dateRange.departureDate
          };
        }
      }
    } else {
      if (!dateRange?.action) {
        //lfcoi
        if (
          faresTransformationLogic === 'histogram' &&
          histogramType !== '' &&
          histogramType !== null
        ) {
          filterModified.histogramType = histogramType;
          filterModified.returnDateRange = {
            start: filterModified.dateRange.start,
            end: filterModified.dateRange.end
          };
          filterModified.dateRange = {
            start: filterModified.dateRange.selected,
            end: filterModified.dateRange.selected
          };
        }
      } else {
        //lfcoiv2
        if (
          dateRange?.action.includes('FLIGHT_TYPE_CHANGE_TO_ROUND_TRIP') ||
          dateRange?.action.includes('FLIGHT_TYPE_CHANGE_TO_ONE_WAY')
        ) {
          //filter changes
          filterModified.histogramType = histogramType;
          if (dateRange?.action === 'FLIGHT_TYPE_CHANGE_TO_ROUND_TRIP') {
            if (dateRange.departureDate) {
              if (isMobile) {
                filterModified.returnDateRange = {
                  start: dateRange.departureDate,
                  end: dateRange.end
                };
                filterModified.dateRange = {
                  start: dateRange.departureDate,
                  end: dateRange.departureDate
                };
              } else {
                let startDate = dateRange.departureDate;
                if (
                  dayjs(dateRange.departureDate).month() !== dayjs(dateRange.start).month() &&
                  dayjs(dateRange.departureDate).month() !== dayjs(dateRange.end).month()
                ) {
                  startDate = dateRange.start;
                }
                filterModified.returnDateRange = {
                  start: startDate,
                  end: dateRange.end
                };
                filterModified.dateRange = {
                  start: dateRange.departureDate,
                  end: dateRange.departureDate
                };
              }
            } else {
              filterModified.histogramType = undefined;
              filterModified.dateRange = {
                start: filterModified.dateRange.start,
                end: filterModified.dateRange.end
              };
            }
          } else if (dateRange?.action === 'FLIGHT_TYPE_CHANGE_TO_ONE_WAY') {
            filterModified.dateRange = {
              start: dateRange.start,
              end: dateRange.end
            };
            if (!isMobile) {
              if (dateRange.departureDate) {
                filterModified.dateRange = {
                  ...filterModified.dateRange,
                  action: `${filterModified.dateRange.action}-update-dparture-fare`,
                  departureDate: dateRange.departureDate
                };
              }
            }
          }
        } else if (
          dateRange.action.includes('NEXT_MONTH') ||
          dateRange.action.includes('PREVIOUS_MONTH')
        ) {
          if (dateRange.action.includes('DEPARTURE_DATE')) {
            filterModified.returnDateRange = {
              start: dateRange.start,
              end: dateRange.end
            };
            filterModified.dateRange = {
              start: dateRange.departureDate,
              end: dateRange.departureDate,
              action: dateRange.action,
              departureDate: dateRange.departureDate,
              returnDate: dateRange.returnDate
            };
            filterModified.histogramType = 'INBOUND';
          } else if (dateRange.action.includes('RETURN_DATE')) {
            if (
              !isMobile &&
              dayjs(dateRange.departureDate).month() !== dayjs(dateRange.returnDate).month() &&
              (dayjs(dateRange.returnDate).month() === dayjs(dateRange.start).month() ||
                dayjs(dateRange.returnDate).month() === dayjs(dateRange.end).month()) &&
              (dayjs(dateRange.departureDate).month() === dayjs(dateRange.start).month() ||
                dayjs(dateRange.departureDate).month() === dayjs(dateRange.end).month())
            ) {
              filterModified['dateBeforeReurnDate'] = {
                dateRange: {
                  start: dateRange.start,
                  end: dateRange.returnDate
                },
                returnDateRange: {
                  start: dateRange.returnDate,
                  end: dateRange.returnDate
                }
              };
              filterModified['dateAfterReurnDate'] = {
                dateRange: {
                  start: dayjs(dateRange.returnDate).add(1, 'day').toDate(),
                  end: dateRange.end
                }
              };
            }
            if (dayjs(dateRange.returnDate).month() === dayjs(dateRange.start).month()) {
              filterModified['dateBeforeReurnDate'] = {
                dateRange: {
                  start: dateRange.start,
                  end: dateRange.returnDate
                },
                returnDateRange: {
                  start: dateRange.returnDate,
                  end: dateRange.returnDate
                }
              };
              if (isMobile) {
                if (
                  dayjs(dateRange.returnDate).add(1, 'day').month() === dayjs(dateRange.end).month()
                ) {
                  filterModified['dateAfterReurnDate'] = {
                    dateRange: {
                      start: dayjs(dateRange.returnDate).add(1, 'day').toDate(),
                      end: dateRange.end
                    }
                  };
                }
              } else {
                if (
                  dayjs(dateRange.returnDate).add(1, 'day').month() ===
                    dayjs(dateRange.end).month() ||
                  dayjs(dateRange.returnDate).add(1, 'day').month() ===
                    dayjs(dateRange.start).month()
                ) {
                  filterModified['dateAfterReurnDate'] = {
                    dateRange: {
                      start: dayjs(dateRange.returnDate).add(1, 'day').toDate(),
                      end: dateRange.end
                    }
                  };
                }
              }
            }
            if (dayjs(dateRange.returnDate).isBefore(dayjs(dateRange.start))) {
              filterModified.dateRange = {
                start: dateRange.start,
                end: dateRange.end,
                departureDate: dateRange.departureDate,
                returnDate: dateRange.returnDate,
                action: dateRange.action
              };
              delete filterModified.returnDateRange;
            } else {
              filterModified.returnDateRange = {
                start: dateRange.returnDate,
                end: dateRange.returnDate
              };
              filterModified.dateRange = {
                start: dateRange.start,
                end: dateRange.end,
                departureDate: dateRange.departureDate,
                returnDate: dateRange.returnDate,
                action: dateRange.action
              };
            }
          }
        } else if (dateRange.action.includes('SELECTED_DEPARTURE_DATE')) {
          if (isMobile) {
            filterModified.returnDateRange = {
              start: dateRange.start,
              end: dateRange.end
            };
            filterModified.dateRange = {
              start: dateRange.departureDate,
              end: dateRange.departureDate
            };
            filterModified.histogramType = 'INBOUND';
          } else {
            filterModified.returnDateRange = {
              start: dateRange.departureDate,
              end: dateRange.end
            };
            filterModified.dateRange = {
              start: dateRange.departureDate,
              end: dateRange.departureDate
            };
            filterModified.histogramType = 'INBOUND';
          }
        }
      }
      if (histogramType === '') {
        filterModified.histogramType = undefined;
      }
    }
  }
  return filterModified;
};

const states = {
  INITIAL: 'INITIAL',
  HIDDEN: 'HIDDEN',
  SKELETON: 'SKELETON',
  COMPLETE: 'COMPLETE',
  WAITING_FOR_DESTINATION: 'WAITING_FOR_DESTINATION',
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  NO_RESULTS: 'NO_RESULTS'
};

let transitions = {
  [states.INITIAL]: {
    feed: states.COMPLETE,
    hide: states.HIDDEN,
    load: states.SKELETON,
    show_no_results: states.NO_RESULTS
  },
  [states.SKELETON]: {
    success: states.COMPLETE,
    failure: states.ERROR,
    show_no_results: states.NO_RESULTS,
    hide: states.HIDDEN
  },
  [states.COMPLETE]: {
    load: states.LOADING,
    wait_for_destination: states.WAITING_FOR_DESTINATION
  },
  [states.WAITING_FOR_DESTINATION]: {
    load: states.LOADING,
    wait_for_destination: states.WAITING_FOR_DESTINATION
  },
  [states.LOADING]: {
    success: states.COMPLETE,
    show_no_results: states.NO_RESULTS,
    failure: states.ERROR
  },
  [states.NO_RESULTS]: {
    load: states.LOADING,
    wait_for_destination: states.WAITING_FOR_DESTINATION
  },
  [states.ERROR]: {
    load: states.LOADING,
    wait_for_destination: states.WAITING_FOR_DESTINATION
  }
};

function reducer(prev, action) {
  const nextState = transitions[prev.value][action.transition];
  if (nextState) {
    return {
      ...prev,
      value: nextState,
      history: prev.value,
      ...action.payload
    };
  }
  return prev;
}

function useQuery({ getData, active = true, initialData }, deps = []) {
  const [firstLoad, setFirstLoad] = useState(initialData);

  useEffect(() => {
    if (!active) {
      return;
    }
    if (firstLoad && initialData) {
      setFirstLoad(false);
      return;
    }
    setFirstLoad(false);
    getData();
    // eslint-disable-next-line
  }, [active, ...deps]);
}

const transformData = (_data, _complementaryData) => {
  let newData = [..._data];
  if (
    _complementaryData[0]?.extraInfo?.locationType !== undefined &&
    _complementaryData[0]?.extraInfo?.locationType !== null
  ) {
    newData.forEach((item, index) => {
      const originIndex = _complementaryData.findIndex(
        (element) => element?.iataCode === item?.origin
      );
      const destinationIndex = _complementaryData.findIndex(
        (element) => element?.iataCode === item?.destination
      );
      if (originIndex !== -1) {
        newData[index]['originLocationType'] =
          _complementaryData[originIndex]?.extraInfo?.locationType;
      }
      if (destinationIndex !== -1) {
        newData[index]['destinationLocationType'] =
          _complementaryData[destinationIndex]?.extraInfo?.locationType;
      }
    });
  }
  return newData;
};

export function useFaresApi({
  getFares,
  prePopulation,
  sorting,
  selectedOrigin,
  budget,
  dateRange: {
    start,
    end,
    flexibleDates,
    availableDays,
    selected,
    departureDate,
    returnDate,
    action
  },
  travelClasses,
  flightType,
  flightStopCount,
  redemptionUnit,
  currency,
  tripDuration,
  travelerInterest,
  rating,
  stops,
  initialData,
  selectedDestination,
  paginationSettings: { step, limit, ...paginationSettings } = {},
  integrationSettings,
  faresTransformationLogic,
  routeMode = false,
  showNoResultsPlaceholder = false,
  getResultsLength,
  minInitialResults,
  meta,
  onLoadMore,
  cache = false,
  cacheDuration = -1,
  selectedAirlines = undefined,
  histogramType,
  enabledhistogram = false,
  hiddenSkeleton = false,
  pageContext,
  travelInterestChangeProcessed,
  combinable,
  ignoreCurrencyCode = false,
  isMobile
}) {
  const resultsLength = getResultsLength(initialData);

  if (enabledhistogram) {
    transitions[states.SKELETON] = {
      success: states.COMPLETE,
      failure: states.ERROR,
      show_no_results: states.NO_RESULTS,
      hide: states.HIDDEN,
      wait_for_destination: states.WAITING_FOR_DESTINATION
    };
  }

  transitions[states.HIDDEN] = {
    success: states.COMPLETE,
    show_no_results: resultsLength < minInitialResults ? states.HIDDEN : states.NO_RESULTS,
    failure: states.ERROR
  };

  //INFO: This transition was created for AirCanada that wants to hide the skeleton of the component
  if (hiddenSkeleton) {
    transitions[states.INITIAL]['load'] = states.HIDDEN;
  }
  let initialState = transitions[states.INITIAL].load;
  if (initialData) {
    if (resultsLength < minInitialResults) {
      initialState = transitions[states.INITIAL].hide;
    } else if (showNoResultsPlaceholder && resultsLength === 0) {
      initialState = transitions[states.INITIAL].show_no_results;
    } else {
      initialState = transitions[states.INITIAL].feed;
    }
  }
  const [{ value: state, data, history }, send] = useReducer(reducer, {
    value: initialState,
    data: initialData,
    history: undefined
  });

  const initialVisibleItems =
    paginationSettings.intialVisibleItems || paginationSettings.initialVisibleItems;
  const [index, setIndex] = useState(initialVisibleItems);
  const [loadedOrigin, setLoadedOrigin] = useState({});
  const [loadedDestination, setLoadedDestination] = useState({});

  const getData = (paginationIndex = initialVisibleItems) => {
    if (
      routeMode &&
      (!Boolean(selectedDestination.value) || !Boolean(selectedOrigin.value)) &&
      transitions[state].wait_for_destination
    ) {
      return Promise.resolve().then(() => {
        send({ transition: 'wait_for_destination' });
      });
    }

    if (transitions[state].load) {
      send({ transition: 'load' });
    }

    return getFares(
      mapFilter({
        prePopulation,
        sorting,
        paginationIndex,
        faresTransformationLogic,
        origin: selectedOrigin.value,
        destination: selectedDestination.value,
        budget,
        travelClasses,
        flightType,
        flightStopCount,
        redemptionUnit,
        tripDuration,
        travelerInterest,
        rating,
        dateRange: {
          start,
          end,
          flexibleDates,
          availableDays,
          selected,
          departureDate,
          returnDate,
          action
        },
        stops,
        isPrePopulation: state === 'SKELETON',
        selectedAirlines: selectedAirlines,
        histogramType,
        combinable,
        ignoreCurrencyCode,
        isMobile
      }),
      integrationSettings,
      faresTransformationLogic,
      meta,
      pageContext,
      cache,
      cacheDuration
    )
      .then((_data) => {
        const includeLocationType = integrationSettings?.v2DeepLinkApiSettings?.includeLocationType;
        if (includeLocationType === true) {
          const marketValue =
            prePopulation.autoSettings?.market ??
            (Array.isArray(prePopulation.markets)
              ? prePopulation.markets[0]
              : prePopulation.markets);

          getAirports(
            {
              market: marketValue,
              ...prePopulation.airport,
              airlineIataCode: prePopulation.airlineIataCode,
              language: prePopulation.languageCode
            },
            integrationSettings,
            meta
          ).then((_complementaryData) => {
            const itemCount = getResultsLength(_data);
            let newData = transformData(_data, _complementaryData);
            if (transitions[state].hide && itemCount < minInitialResults) {
              send({ transition: 'hide' });
            } else if (showNoResultsPlaceholder && itemCount === 0) {
              send({ transition: 'show_no_results', payload: { data: newData } });
            } else {
              send({ transition: 'success', payload: { data: newData } });
            }
            setLoadedOrigin(selectedOrigin);
            setLoadedDestination(selectedDestination);
            setIndex(paginationIndex);
          });
        } else {
          const itemCount = getResultsLength(_data);
          if (transitions[state].hide && itemCount < minInitialResults) {
            send({ transition: 'hide' });
          } else if (showNoResultsPlaceholder && itemCount === 0) {
            send({ transition: 'show_no_results', payload: { data: _data } });
          } else {
            send({ transition: 'success', payload: { data: _data } });
          }
          setLoadedOrigin(selectedOrigin);
          setLoadedDestination(selectedDestination);
          setIndex(paginationIndex);
        }
      })
      .catch((err) => {
        send({ transition: 'failure' });
        setLoadedOrigin(selectedOrigin);
        setLoadedDestination(selectedDestination);
        throw err;
      });
  };

  const hasMore = () => {
    const itemCount = getResultsLength(data);
    return itemCount < limit && itemCount >= index;
  };

  const loadMore = (_, withKeyboard) => {
    if (hasMore()) {
      // TODO: In some configuration cases, the current step + index may exceed the limit set by settings.
      //       In that case, check if the query cap is greater than the limit, then overwrite the newIndex with the limit.
      const newIndex = step + index > limit ? limit : step + index;
      getData(newIndex);
      if (onLoadMore) {
        onLoadMore({ oldIndex: index, newIndex, withKeyboard });
      }
    }
  };

  useQuery(
    {
      getData,
      initialData
    },
    [
      selectedOrigin,
      selectedDestination,
      faresTransformationLogic,
      integrationSettings,
      prePopulation,
      sorting,
      travelClasses,
      flightType,
      flightStopCount,
      redemptionUnit,
      currency,
      tripDuration,
      rating,
      stops,
      start,
      end,
      budget,
      meta,
      flexibleDates,
      selectedAirlines,
      travelInterestChangeProcessed
    ]
  );

  function match(stateValue) {
    if (isSSR() && stateValue === 'SKELETON') {
      return true;
    }
    return stateValue === state || (state === states.LOADING && history === stateValue);
  }

  return {
    state,
    data,
    history,
    match,
    retry: () => getData(),
    loadMore,
    hasMore,
    loadedOrigin,
    loadedDestination
  };
}
